import { jsx as o } from "react/jsx-runtime";
import { components as t } from "react-select";
import i from "./Select.module.css.js";
import { Tooltip as l } from "../Tooltip/Tooltip.js";
import { Close as m } from "../../foundations/icons/Close.js";
const p = ({ ...e }) => e.selectProps.isDisabled ? null : /* @__PURE__ */ o(l, { tooltip: "Remove", delay: 300, positioning: "fixed", children: /* @__PURE__ */ o("div", { className: i.removeButtonContainer, children: /* @__PURE__ */ o(t.MultiValueRemove, { ...e, children: /* @__PURE__ */ o(m, { className: i.closeIcon }) }) }) });
export {
  p as MultiValueRemove
};
//# sourceMappingURL=MultiValueRemove.js.map
